/**
 * `.compteur` du kit, en dense : une quantité qu'on règle au doigt ou qu'on tape. Les deux
 * boutons portent leur nom (`aria-label`), la valeur est une vraie saisie.
 */
export function QtyStepper({
  value,
  onChange,
  min = 1,
  max = 99,
  label = 'Quantité',
}: {
  value: number;
  onChange: (n: number) => void;
  min?: number;
  max?: number;
  label?: string;
}): React.ReactElement {
  return (
    <div className="compteur-commandes" role="group" aria-label={label}>
      <button
        type="button"
        className="compteur-bouton"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        aria-label="Diminuer la quantité"
      >
        −
      </button>
      <input
        className="compteur-valeur"
        inputMode="numeric"
        value={value}
        onChange={(e) => {
          const n = Number(e.target.value);
          if (Number.isFinite(n)) onChange(Math.min(max, Math.max(min, Math.round(n))));
        }}
        aria-label={label}
      />
      <button
        type="button"
        className="compteur-bouton"
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        aria-label="Augmenter la quantité"
      >
        +
      </button>
    </div>
  );
}
